module.exports = __webpack_public_path__ + "images/Close.8ac82beb9e6d295bac7517f94b2a7383.svg";